import axios from "axios";

export const createRewardBatch = async (name, items, idempotencyKey) => {
    const body = { name, data: items };
    const headers = { "idempotency-key": idempotencyKey };
    const resp = await axios.post(`/reward-voucher/batch`, body, { headers });
    return resp.data;
};

export const getRewardBatches = async (company, dates, status, filter, page = 0, size = 10) => {
    const res = await axios.get(`/reward-voucher/batch`, {
        params: {
            page,
            size,
            ...(company ? { company } : {}),
            ...(dates ? { dates } : {}),
            ...(status ? { status } : {}),
            ...(filter ? { filter: filter.trim() } : {}),
        }
    });
    return res.data;
};

export const getRewardBatch = async (batchId, page = 0, size = 10, status = null, filter = null) => {
    const res = await axios.get(`/reward-voucher/batch/${batchId}`, {
        params: {
            page,
            size,
            ...(status ? { status } : {}),
            ...(filter ? { filter: filter.trim() } : {}),
        }
    });
    return res.data;
};

export const cancelRewardBatch = async (batchId) => {
    const resp = await axios.delete(`/reward-voucher/batch/${batchId}`);
    return resp.data;
};

export const exportRewardBatches = async (batchIds) => {
    const resp = await axios.post(`/reward-voucher/batch/export`, { batchIds });
    return resp.data;
};
